export const BLOOD = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];

export const CYCLE_OPTIONS = ['1', '2', '3', '4', '5', 'Other'];

export const FREQUENCY_OPTIONS = ['0', '1', '2', '3', 'More than 3'];

export const REMEDY_OPTIONS = [
  'Nothing (કંઈ નહીં)',
  'Medicines (દવા)',
  'Home Remedies (ઘરગથ્થુ ઉપચાર)',
  'Other (અન્ય)',
];

export const DIAGNOSIS_OPTIONS = [
  'Breast Cancer (સ્તન કેન્સર)',
  'Oral Cavity Cancer (મુખ, જીભ, હોઠ, ગાલના કેન્સર)',
  'Cervical Cancer (ગર્ભાશયના મુખનું કેન્સર)',
];

export const DRUG_REGIMENS = {
  'Breast Cancer (સ્તન કેન્સર)': [
    'Paclitaxel(પેક્લિટેક્સેલ)',
    'Trastuzumab(ટ્રાસ્ટુઝુમેબ)',
    'Capecitabine(કેપેસિટાબિન)',
    'Exemestane(એક્ઝેમેસ્ટેન)',
    'Tamoxifen(ટેમોક્સિફેન)',
    'Letrozole(લેટ્રોઝોલ)',
    'Lapatinib(લાપાટિનિબ)',
    'Fulvestrant(ફુલ્વેસ્ટ્રાન્ટ)',
    'Carboplatin + Paclitaxel(કાર્બોપ્લેટિન + પેક્લિટેક્સેલ)',
    'Carboplatin + Gemcitabine(કાર્બોપ્લેટિન + જેમસિટાબિન)',
    'Cyclophosphamide + Epirubcin(સાયક્લોફોસ્ફામાઇડ + એપિરુબિસિન)',
    'Cyclophosphamide + Adriamycin(સાયક્લોફોસ્ફામાઇડ + એડ્રિયામાયસિન)',
    'Docetaxel + Cyclophosphamide(ડોસેટેક્સેલ + સાયક્લોફોસ્ફામાઇડ)',
    'Cyclophosphamide + Methotrexate + 5-FU(5-Fluorouracil){સાયક્લોફોસ્ફામાઇડ + મેથોટ્રેક્સેટ + 5-એફયુ (5-ફ્લુઓરોયુરાસિલ)}',
  ],

  'Oral Cavity Cancer (મુખ, જીભ, હોઠ, ગાલના કેન્સર)': [
    'Cisplatin(સિસ્પ્લેટિન)',
    'Docetaxel(ડોસેટેક્સેલ)',
    'Paclitaxel(પેક્લિટેક્સેલ)',
    'Carboplatin(કાર્બોપ્લેટિન)',
    'Gemcitabine(જેમસિટાબિન)',
    'Cisplatin + Docetaxel(સિસ્પ્લેટિન + ડોસેટેક્સેલ)',
    'Etoposide + Cisplatin(ઇટોપોસાઇડ + સિસ્પ્લેટિન)',
    'Gemcitabine + Cisplatin(જેમસિટાબિન  + સિસ્પ્લેટિન)',
    'Cisplatin + Methotrexate(સિસ્પ્લેટિન + મેથોટ્રેક્સેટ)',
    'Paclitaxel + Carboplatin(પેક્લિટેક્સેલ + કાર્બોપ્લેટિન)',
    'Etoposide + Carboplatin(ઇટોપોસાઇડ + કાર્બોપ્લેટિન)',
    'Carboplatin + Gemcitabine(કાર્બોપ્લેટિન + જેમસિટાબિન)',
    'Docetaxel + Cisplatin + 5 FU(5-Fluorouracil){ડોસેટેક્સેલ + સિસ્પ્લેટિન + 5-એફયુ (5-ફ્લુઓરોયુરાસિલ)}',
  ],

  'Cervical Cancer (ગર્ભાશયના મુખનું કેન્સર)': [
    'Carboplatin + Paclitaxel(કાર્બોપ્લેટિન + પેક્લિટેક્સેલ)',
    'Cisplatin(સિસ્પ્લેટિન)',
  ],
};

export const SIDE_EFFECTS = {
  'Carboplatin(કાર્બોપ્લેટિન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Hair loss (વાળ ખરવા)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Back Pain (પીઠનો દુખાવો)',
    'Injection site pain (ઇન્જેક્શન આપેલી જગ્યાએ દુખાવો)',
    'Numbness (ઝણઝણાટી થવી)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Muscle Pain (સ્નાયુનો દુખાવો)',
    'Memory Loss (યાદશક્તિ ઘટવી)',
    'Headache (માથાનો દુખાવો થવો)',
    'Dizziness (ચક્કર આવવા)',
  ],

  'Carboplatin + Paclitaxel(કાર્બોપ્લેટિન + પેક્લિટેક્સેલ)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Hair loss (વાળ ખરવા)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Back Pain (પીઠનો દુખાવો)',
    'Injection site pain (ઇન્જેક્શન આપેલી જગ્યાએ દુખાવો)',
    'Numbness (ઝણઝણાટી થવી)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Memory Loss (યાદશક્તિ ઘટવી)',
    'Headache (માથાનો દુખાવો થવો)',
    'Dizziness (ચક્કર આવવા)',
    'Low Blood Pressure (BP ઓછું થવું)',
    'Fever (તાવ આવવો)',
    'Seizure/Abnormal Movement (ખેંચ આવવી)',
    'Scaling of the Skin (ચામડી પર પડ ઉતરવા)',
    'Decrease in Heartbeat (હૃદયના ધબકારા ધીમા પડવા)',
  ],

  'Docetaxel(ડોસેટેક્સેલ)': [
    'Hair loss (વાળ ખરવા)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Fever (તાવ આવવો)',
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Constipation (કબજિયાત)',
    'Pain in stomach (પેટમાં દુખાવો થવો)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Blood in stool (મળમાં લોહી આવવું)',
    'Nail changes (નખમાં ફેરફાર થવો)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Numbness (ઝણઝણાટી થવી)',
    'Increase in heartbeat (હૃદયના ધબકારા વધવા)',
    'Chest Pain (છાતીમાં દુખાવો થવો)',
    'Heart attack (હૃદયરોગનો હુમલો આવવો)',
    'Fainting (બેહોશ થઈ જવું)',
    'Injection site pain, inflammation, necrosis (ઇન્જેક્શન આપેલી જગ્યાએ દુખાવો, સોજો, પેશીઓ નાશ પામવી)',
  ],

  'Cisplatin + Docetaxel(સિસ્પ્લેટિન + ડોસેટેક્સેલ)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Tinnitus (કાનમાં અવાજ આવવો)',
    'Deafness/Decrease in hearing (બહેરાશ / સાંભળવાની ક્ષમતામાં ઘટાડો થવો)',
    'Facial edema (ચહેરા પર સોજો આવવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Seizure/Abnormal Movement (ખેંચ આવવી)',
    'Low Blood Pressure (BP ઓછું થવું)',
    'Increase in heartbeat (હૃદયના ધબકારા વધવા)',
    'Decrease in urine (પેશાબ ઓછો થવો)',
    'Blood in urine or stool (પેશાબ અથવા મળમાં લોહી આવવું)',
    'Hair loss (વાળ ખરવા)',
    'Fever (તાવ આવવો)',
    'Constipation (કબજિયાત)',
    'Pain in stomach (પેટમાં દુખાવો થવો)',
    'Nail changes (નખમાં ફેરફાર થવો)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Numbness (ઝણઝણાટી થવી)',
    'Chest Pain (છાતીમાં દુખાવો થવો)',
    'Heart attack (હૃદયરોગનો હુમલો આવવો)',
    'Fainting (બેહોશ થઈ જવું)',
    'Injection site pain, inflammation, necrosis (ઇન્જેક્શન આપેલી જગ્યાએ દુખાવો, સોજો, પેશીઓ નાશ પામવી)',
  ],

  'Paclitaxel + Carboplatin(પેક્લિટેક્સેલ + કાર્બોપ્લેટિન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Hair loss (વાળ ખરવા)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Fever (તાવ આવવો)',
    'Back Pain (પીઠનો દુખાવો)',
    'Injection site pain (ઇન્જેક્શન આપેલી જગ્યાએ દુખાવો)',
    'Numbness (ઝણઝણાટી થવી)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Memory Loss (યાદશક્તિ ઘટવી)',
    'Headache (માથાનો દુખાવો થવો)',
    'Dizziness (ચક્કર આવવા)',
    'Low Blood Pressure (BP ઓછું થવું)',
    'Seizure/Abnormal Movement (ખેંચ આવવી)',
    'Scaling of the Skin (ચામડી પર પડ ઉતરવા)',
    'Decrease in Heartbeat (હૃદયના ધબકારા ધીમા પડવા)',
  ],

  'Gemcitabine + Cisplatin(જેમસિટાબિન  + સિસ્પ્લેટિન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Tinnitus (કાનમાં અવાજ આવવો)',
    'Deafness/Decrease in hearing (બહેરાશ / સાંભળવાની ક્ષમતામાં ઘટાડો થવો)',
    'Facial edema (ચહેરા પર સોજો આવવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Seizure/Abnormal Movement (ખેંચ આવવી)',
    'Low Blood Pressure (BP ઓછું થવું)',
    'Increase in heartbeat (હૃદયના ધબકારા વધવા)',
    'Decrease in urine (પેશાબ ઓછો થવો)',
    'Blood in urine or stool (પેશાબ અથવા મળમાં લોહી આવવું)',
    'Fever (તાવ આવવો)',
    'Cough (ઉધરસ આવવી)',
    'Chills (ઠંડી લાગવી / ધ્રુજારી થવી)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Hair loss (વાળ ખરવા)',
  ],

  'Gemcitabine(જેમસિટાબિન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Constipation (કબજિયાત)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Fever (તાવ આવવો)',
    'Cough (ઉધરસ આવવી)',
    'Chills (ઠંડી લાગવી / ધ્રુજારી થવી)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Hair loss (વાળ ખરવા)',
    'Edema (સોજો આવવો)',
    'Blood in urine (પેશાબમાં લોહી આવવું)',
  ],

  'Etoposide(ઇટોપોસાઇડ)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Constipation (કબજિયાત)',
    'Pain in stomach (પેટમાં દુખાવો થવો)',
    'Difficulty in Swallowing (ખોરાક ગળવામાં તકલીફ થવી)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Fever (તાવ આવવો)',
    'Cough (ઉધરસ આવવી)',
    'Chills (ઠંડી લાગવી / ધ્રુજારી થવી)',
    'Chest Pain (છાતીમાં દુખાવો થવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Bleeding Gums (પેઢાંમાંથી લોહી આવવું)',
    'Skin Pigmentation (ચામડી ના રંગમાં ફેરફાર થવો)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Hair loss (વાળ ખરવા)',
    'Headache (માથાનો દુખાવો થવો)',
    'Dizziness (ચક્કર આવવા)',
    'Blurred Vision (ધૂંધળું દેખાવું / ઝાંખું દેખાવું)',
    'Blood in urine or stool (પેશાબ અથવા મળમાં લોહી આવવું)',
  ],

  'Tamoxifen(ટેમોક્સિફેન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Hot Flashes (શરીરમાં તીવ્ર ગરમીનો અનુભવ થવો)',
    'Vaginal Discharge (યોનિમાંથી પાણી આવવું)',
    'Irregular Periods/Menstruation (અનિયમિત માસિક આવવું)',
    'No periods/Decrease in Periods/Menstruation (માસિક ન આવવું/ માસિક ઓછું આવવું)',
    'Bone Pain (હાડકાંમાં દુખાવો)',
    'Muscle Pain (સ્નાયુનો દુખાવો)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Cataract (મોતિયો)',
    'Depression (ખૂબ ઉદાસી અથવા નિરાશા અનુભવવી)',
    'Swelling of the lips, face, tongue, or around the eyes (હોઠ, ચહેરા, જીભ અથવા આંખોની આસપાસ સોજો આવવો)',
  ],

  'Letrozole(લેટ્રોઝોલ)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Constipation (કબજિયાત)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Fever (તાવ આવવો)',
    'Cough (ઉધરસ આવવી)',
    'Chills (ઠંડી લાગવી / ધ્રુજારી થવી)',
    'Headache (માથાનો દુખાવો થવો)',
    'Back Pain (પીઠનો દુખાવો)',
    'Dry Skin (સૂકી ચામડી)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Burning passing urine (પેશાબ કરતી વખતે બળતરા થવી)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Hair loss (વાળ ખરવા)',
    'Dry Eye (આંખ સૂકી લાગવી)',
    'Pain in stomach (પેટમાં દુખાવો થવો)',
    'White spots on the skin/Vitiligo (ચામડી પર સફેદ ડાઘ થવા)',
  ],

  'Cisplatin(સિસ્પ્લેટિન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Tinnitus (કાનમાં અવાજ આવવો)',
    'Deafness/Decrease in hearing (બહેરાશ / સાંભળવાની ક્ષમતામાં ઘટાડો થવો)',
    'Facial edema (ચહેરા પર સોજો આવવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Seizure/Abnormal Movement (ખેંચ આવવી)',
    'Low Blood Pressure (BP ઓછું થવું)',
    'Increase in heartbeat (હૃદયના ધબકારા વધવા)',
    'Decrease in urine (પેશાબ ઓછો થવો)',
    'Blood in urine or stool (પેશાબ અથવા મળમાં લોહી આવવું)',
  ],

  'Paclitaxel(પેક્લિટેક્સેલ)': [
    'Hair loss (વાળ ખરવા)',
    'Anemia/Decrease in haemoglobin (લોહીના ટકા ઘટવા)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Numbness (ઝણઝણાટી થવી)',
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Low Blood Pressure (BP ઓછું થવું)',
    'Fever (તાવ આવવો)',
    'Seizure/Abnormal Movement (ખેંચ આવવી)',
    'Scaling of the Skin (ચામડી પર પડ ઉતરવા)',
    'Decrease in Heartbeat (હૃદયના ધબકારા ધીમા પડવા)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
  ],

  'Adriamycin(એડ્રિયામાયસિન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Pain in stomach (પેટમાં દુખાવો થવો)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Mouth Ulcer (મોઢામાં ચાંદા પડવા)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Increase in heartbeat (હૃદયના ધબકારા વધવા)',
    'Skin Pigmentation (ચામડી ના રંગમાં ફેરફાર થવો)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Hair loss (વાળ ખરવા)',
    'Nail changes (નખમાં ફેરફાર થવો)',
    'Blood in stool (મળમાં લોહી આવવું)',
  ],

  '5-FU(5-Fluorouracil)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Constipation (કબજિયાત)',
    'Fever (તાવ આવવો)',
    'Chills (ઠંડી લાગવી / ધ્રુજારી થવી)',
    'Headache (માથાનો દુખાવો થવો)',
    'Hair loss (વાળ ખરવા)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Blood in urine or stool (પેશાબ અથવા મળમાં લોહી આવવું)',
    'Back Pain (પીઠનો દુખાવો)',
    'Dry Skin (સૂકી ચામડી)',
    'Skin Pigmentation (ચામડી ના રંગમાં ફેરફાર થવો)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Dizziness (ચક્કર આવવા)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Chest Pain (છાતીમાં દુખાવો થવો)',
    'Burning passing urine (પેશાબ કરતી વખતે બળતરા થવી)',
    'Conjunctivitis/Eye infection (આંખ આવવી / આંખમાં ચેપ લાગવો)',
    'Blurred Vision (ધૂંધળું દેખાવું / ઝાંખું દેખાવું)',
    'Redness, pain, burning, swelling, or peeling of the skin on the hands and feet (હાથ અને પગની ચામડી લાલ થવી, બળતરા થવી, દુખાવો થવો અથવા ચામડી ઉતરવી)',
  ],

  'Capecitabine(કેપેસિટાબિન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Constipation (કબજિયાત)',
    'Pain in stomach (પેટમાં દુખાવો થવો)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Dry Mouth (મોઢું સૂકાવું)',
    'Eye Irritation (આંખમાં બળતરા થવી / આંખમાં ખંજવાળ થવી)',
    'Fever (તાવ આવવો)',
    'Hair loss (વાળ ખરવા)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Chest Pain (છાતીમાં દુખાવો થવો)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Edema (સોજો આવવો)',
    'Back Pain (પીઠનો દુખાવો)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Redness, pain, burning, swelling, or peeling of the skin on the hands and feet (હાથ અને પગની ચામડી લાલ થવી, બળતરા થવી, દુખાવો થવો અથવા ચામડી ઉતરવી)',
  ],

  'Trastuzumab(ટ્રાસ્ટુઝુમેબ)': [
    'Fever (તાવ આવવો)',
    'Headache (માથાનો દુખાવો થવો)',
    'Chills (ઠંડી લાગવી / ધ્રુજારી થવી)',
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Cough (ઉધરસ આવવી)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Edema (સોજો આવવો)',
    'Muscle Pain (સ્નાયુનો દુખાવો)',
    'Insomnia (ઊંઘ ન આવવી)',
    'Dizziness (ચક્કર આવવા)',
    'High Blood Pressure (BP વધી જવું)',
    'Back Pain (પીઠનો દુખાવો)',
    'Nail changes (નખમાં ફેરફાર થવો)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Burning passing urine (પેશાબ કરતી વખતે બળતરા થવી)',
  ],

  'Fulvestrant(ફુલ્વેસ્ટ્રાન્ટ)': [
    'Diarrhea (ઝાડા)',
    'Constipation (કબજિયાત)',
    'Fever (તાવ આવવો)',
    'Dry Skin (સૂકી ચામડી)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Hair loss (વાળ ખરવા)',
    'Headache (માથાનો દુખાવો થવો)',
    'Back Pain (પીઠનો દુખાવો)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Edema (સોજો આવવો)',
    'Blurred Vision (ધૂંધળું દેખાવું / ઝાંખું દેખાવું)',
    'Injection site pain, inflammation, necrosis (ઇન્જેક્શન આપેલી જગ્યાએ દુખાવો, સોજો, પેશીઓ નાશ પામવી)',
    'Depression (ખૂબ ઉદાસી અથવા નિરાશા અનુભવવી)',
    'Insomnia (ઊંઘ ન આવવી)',
    'Bleeding Gums (પેઢાંમાંથી લોહી આવવું)',
  ],

  'Exemestane(એક્ઝેમેસ્ટેન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Headache (માથાનો દુખાવો થવો)',
    'Back Pain (પીઠનો દુખાવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Chest Pain (છાતીમાં દુખાવો થવો)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Itching (ખંજવાળ આવવી)',
    'Fever (તાવ આવવો)',
    'Chills (ઠંડી લાગવી / ધ્રુજારી થવી)',
    'Cough (ઉધરસ આવવી)',
    'Hot Flashes (શરીરમાં તીવ્ર ગરમીનો અનુભવ થવો)',
    'Depression (ખૂબ ઉદાસી અથવા નિરાશા અનુભવવી)',
    'Insomnia (ઊંઘ ન આવવી)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Hair loss (વાળ ખરવા)',
    'Edema (સોજો આવવો)',
    'Burning passing urine (પેશાબ કરતી વખતે બળતરા થવી)',
    'Blurred Vision (ધૂંધળું દેખાવું / ઝાંખું દેખાવું)',
  ],

  'Lapatinib(લાપાટિનિબ)': [
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Dry Skin (સૂકી ચામડી)',
    'Itching (ખંજવાળ આવવી)',
    'Skin Pigmentation (ચામડી ના રંગમાં ફેરફાર થવો)',
    'Scaling of the Skin (ચામડી પર પડ ઉતરવા)',
    'Nail changes (નખમાં ફેરફાર થવો)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Hair loss (વાળ ખરવા)',
    'Fever (તાવ આવવો)',
    'Cough (ઉધરસ આવવી)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Joint Pain/Muscle Pain (સાંધાનો દુખાવો/ સ્નાયુનો દુખાવો)',
    'Insomnia (ઊંઘ ન આવવી)',
    'Epistaxis/Nosebleed (નાકમાંથી લોહી આવવું)',
  ],

  'Epirubicin(એપિરુબિસિન)': [
    'Nausea (ઉબકા)',
    'Vomiting (ઉલટી)',
    'Diarrhea (ઝાડા)',
    'Constipation (કબજિયાત)',
    'Fever (તાવ આવવો)',
    'Chills (ઠંડી લાગવી / ધ્રુજારી થવી)',
    'Weakness/Fatigue (નબળાઈ/થાક લાગવો)',
    'Headache (માથાનો દુખાવો થવો)',
    'Difficulty in breathing (શ્વાસ લેવામાં તકલીફ પડવી)',
    'Chest Pain (છાતીમાં દુખાવો થવો)',
    'Hair loss (વાળ ખરવા)',
    'Skin rash/papules (લાલ ચકામા, ફોલ્લીઓ થવી)',
    'Dry Skin (સૂકી ચામડી)',
    'Itching (ખંજવાળ આવવી)',
    'Nail changes (નખમાં ફેરફાર થવો)',
    'Loss of appetite/Decrease in food intake (ભૂખ ન લાગવી / ખોરાકનું સેવન ઓછું થવું)',
    'Mouth Ulcer (મોઢામાં ચાંદા પડવા)',
    'Dry Eye (આંખ સૂકી લાગવી)',
    'Conjunctivitis/Eye infection (આંખ આવવી / આંખમાં ચેપ લાગવો)',
    'No periods/Decrease in Periods/Menstruation (માસિક ન આવવું/ માસિક ઓછું આવવું)',
    'Depression (ખૂબ ઉદાસી અથવા નિરાશા અનુભવવી)',
    'Insomnia (ઊંઘ ન આવવી)',
    'Injection site pain, inflammation, necrosis (ઇન્જેક્શન આપેલી જગ્યાએ દુખાવો, સોજો, પેશીઓ નાશ પામવી)',
  ],
};

export const getEnglishDrugName = (value) => value.split(/[({]/)[0].trim();

const normalizeDrugName = (value) =>
  getEnglishDrugName(value).toLowerCase().replace(/[\s-]/g, '');

export const getSideEffectsForRegimen = (drugRegimen) => {
  if (!drugRegimen) {
    return [];
  }

  const regimenName = getEnglishDrugName(drugRegimen);

  if (!regimenName.includes('+')) {
    return SIDE_EFFECTS[drugRegimen] || [];
  }

  const combinedSideEffects = regimenName
    .split('+')
    .map((drugName) => drugName.trim())
    .flatMap((drugName) => {
      const matchingKey = Object.keys(SIDE_EFFECTS).find(
        (key) => normalizeDrugName(key) === normalizeDrugName(drugName)
      );

      return matchingKey ? SIDE_EFFECTS[matchingKey] : [];
    });

  return combinedSideEffects.length > 0
    ? [...new Set(combinedSideEffects)]
    : SIDE_EFFECTS[drugRegimen] || [];
};

export const initialState = {
  name: '',
  age: '',
  gender: '',
  phone: '',
  regNo: '',
  bloodGroup: '',
  address: '',
  reportDate: '',
  diagnosis: '',
  reactionDate: '',
  drugRegimen: '',
  sideEffects: [],
  sideEffectCycles: {},
};
